const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGOUT: 'LOGOUT',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  JWT_LOGIN_REQUEST: 'JWT_LOGIN_REQUEST',
  FIRST_LOGIN_REQUEST: 'FIRST_LOGIN_REQUEST',
  SSO_LOGIN_REQUEST: 'SSO_LOGIN_REQUEST',
  FIRST_LOGIN_ERROR:'FIRST_LOGIN_ERROR',
  ITSME_LOGIN_REQUEST: 'ITSME_LOGIN_REQUEST',

  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),
  login: (token = false) => ({
    type: actions.LOGIN_REQUEST,
    payload: { token },
  }),
  logout: () => ({
    type: actions.LOGOUT,
  }),
  jwtLogin: (history, userInfo) => ({
    type: actions.JWT_LOGIN_REQUEST,
    payload: { history, userInfo }
  }),
  firstLogin:(history, userInfo,hit) => ({
    type: actions.FIRST_LOGIN_REQUEST,
    payload: { history, userInfo,hit }
  }),
  ssoLogin: (userInfo) => ({
    type: actions.SSO_LOGIN_REQUEST,
    payload: {userInfo }
  }),
  itsmeLogin: (userInfo) => ({
    type: actions.ITSME_LOGIN_REQUEST,
    payload: {userInfo }
  }),
};

export default actions;
